import {vue} from "../../../main";

export const receptionModule = {
    namespaced: true,
    state: {},
    getters: {

        allStatus() {
            return [
                {value: "queued", text: ("QUEUED")},
                {value: "ringing", text: ("RINGING")},
                {value: "in-progress", text: ("IN_PROGRESS")},
                {value: "completed", text: ("COMPLETED")},
                {value: "busy", text: ("BUSY")},
                {value: "failed", text: ("FAILED")},
                {value: "no-answer", text: ("NO_ANSWER")},
                {value: "canceled", text: ("CANCELED")}
            ];
        },
  allStatusMessages() {
            return [
                {value: "delivered", text: ("DELIVERED")},
                {value: "failed", text: ("FAILED")},
            ];
        }


    },
    mutations: {},
    actions: {
        fetchAllCalls(actions, {filter}) {
            // console.log("fetchAllProviders", {page, amount, filter, sortcolumn, sortby});
            let params = {
                pageUrl: filter.pageUrl || null
            };
            return this.$api.baseApi().post('/twillio/getAllCalls', filter, {params})
                .then(response => {
                    return response.data?.objects;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['calls']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        fetchAllMessages(actions, {filter}) {
            // console.log("fetchAllProviders", {page, amount, filter, sortcolumn, sortby});
            let params = {
                pageUrl: filter.pageUrl || null
            };
            return this.$api.baseApi().post('/twillio/getAllMessages', filter, {params})
                .then(response => {
                    return response.data?.objects;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['messages']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },

        /* fetchAllCalls(actions, { filter }) {
             const params = {
                 buid: filter.buid,
                 pageUrl: filter.pageUrl || null
             };

             return this.$api.baseApi().get('/calls/page', {
                 params,
                 data: filter  // Vue Axios will send this as the request body
             })
                 .then(response => {
                     return {
                         calls: response.data.objects.calls,
                         nextPageUrl: response.data.objects.nextPageUrl,
                         previousPageUrl: response.data.objects.previousPageUrl
                     };
                 })
                 .catch(error => {
                     actions.dispatch('notifications/error',
                         {
                             title: { text: '%s - failed to retrieve', arguments: ['calls'] },
                             message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                         },
                         { root: true });
                     return error;
                 });
         }
 */

        fetchServiceById(actions, id) {
            return this.$api.baseApi().get(`/twillio/call/id/${id}`)
                .then(response => {
                    return response.data?.objects.service;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['call']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },

    }
}
